import { DeliveryStatus } from '../../../../../../services/exports/Constants';

export default {
  title: 'Entregas externas',
  fields: {
    pickup: 'Recogida',
    dropoff: 'Entrega',
    status: 'Estado',
    estimated_time: 'Tiempo estimado',
    actual_time: 'Tiempo real',
    actions: 'Acciones',
    time: 'Hora',
    pickup_estimate: 'Estimación de recogida',
    dropoff_estimate: 'Estimación de entrega',
  },
  labels: {
    pickup: 'Recogida',
    dropoff: 'Entrega',
  },
  delivery_statuses: {
    [DeliveryStatus.Pending]: 'Conductor pendiente',
    [DeliveryStatus.RunnerAssigned]: 'Conductor asignado',
    [DeliveryStatus.OnRoutePickup]: 'En camino a recogida',
    [DeliveryStatus.ArrivedPickup]: 'Llegó a recogida',
    [DeliveryStatus.PickedUp]: 'Recogido',
    [DeliveryStatus.OnRouteDropoff]: 'En camino a entrega',
    [DeliveryStatus.ArrivedDropoff]: 'Llegó a entrega',
    [DeliveryStatus.Completed]: 'Completado',
    [DeliveryStatus.Cancelled]: 'Cancelado',
  },
  buttons: {
    actions: 'Acciones',
    open_tracking_url: 'Rastrear entrega',
    show_order_details: 'Ver detalles del pedido',
    call_restaurant: 'Llamar al restaurante',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
  },
};
